module.exports = __webpack_public_path__ + "img/round8.ec8f9faf.png";